<template>
  <div class="survey-owner clearfix">
    <companyTitle></companyTitle>
    <b-button
      class="mr-3 mt-3 float-right"
      type="button"
      variant="primary"
      @click="$router.push({ name: 'oneSurvey-create' })"
      >新增</b-button
    >
    <b-pagination-nav
      :link-gen="linkGen"
      :number-of-pages="$store.getters.paginationInSurveyOwner.last_page"
      @change="$store.dispatch('fetchSurveyOwner', $event)"
      use-router
      class="mt-3"
    ></b-pagination-nav>
    <tableList
      :isSelectable="true"
      :fields="fields"
      :items="$store.getters.surveyOwnerList"
      :sort-by.sync="sortBy"
      @click="openModal($event)"
      @toDetail="toDetail"
    >
    </tableList>
    <tableListNoData
      v-if="$store.getters.surveyOwnerList.length === 0"
    ></tableListNoData>

    <!-- modal -->
    <b-modal ref="double-check-delete-surveyOwner">
      <p class="text-center">是否刪除？</p>
      <template v-slot:modal-footer>
        <div class="text-center">
          <b-button @click="submit" class="mr-3" type="button" variant="primary"
            >確定</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import tableList from "@/components/TableList.vue";
import tableListNoData from "@/components/TableListNoData.vue";
import companyTitle from "@/components/CompanyTitle.vue";
export default {
  components: {
    tableList,
    tableListNoData,
    companyTitle
  },
  computed: {
    sortBy() {
      return "";
    },
    fields() {
      return [
        { key: "released_at", label: "發布日期", sortable: true },
        { key: "title", label: "標題", sortable: true },
        { key: "user", label: "撰寫者", sortable: true }
      ];
    }
  },
  data() {
    return {
      deleteData: {
        research_ids: []
      }
    };
  },
  methods: {
    openModal(selectedList) {
      this.$refs["double-check-delete-surveyOwner"].show();
      this.setDeleteData(selectedList);
    },
    setDeleteData(selectedList) {
      this.deleteData.research_ids = selectedList.map(item => item.id);
    },
    submit() {
      this.$store.dispatch("deleteOneSurvey", this.deleteData).then(() => {
        this.$refs["double-check-delete-surveyOwner"].hide();
        const page = 1;
        this.$store.dispatch("fetchSurveyOwner", page);
      });
    },
    toDetail(oneSurvey) {
      this.$router.push({
        name: "oneSurvey-edit",
        params: { oneSurveyId: oneSurvey.id }
      });
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
